module.exports = __webpack_public_path__ + "img/mobile_white.311a844f.svg";